import React from "react";

type EventSkeletonLoaderProps = {
  count?: number;
};

const EventSkeletonLoader: React.FC<EventSkeletonLoaderProps> = ({ count = 3 }) => {
  return (
    <div className="p-6 space-y-6 animate-pulse">
      {/* Filter/Search Bar */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        <div className="h-10 bg-gray-200 rounded col-span-2"></div>
        <div className="h-10 bg-gray-200 rounded col-span-1"></div>
        <div className="h-10 bg-gray-200 rounded col-span-1"></div>
        <div className="h-10 bg-gray-200 rounded col-span-1"></div>
      </div>

      {/* Events Found Heading */}
      <div className="h-6 w-40 bg-gray-200 rounded"></div>

      {/* Event Cards Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array.from({ length: count }).map((_, index) => (
          <div
            key={index}
            className="bg-white p-4 rounded shadow space-y-4"
          >
            <div className="h-36 bg-gray-200 rounded"></div>
            <div className="flex justify-between items-center">
              <div className="h-4 w-24 bg-gray-200 rounded"></div>
              <div className="h-4 w-8 bg-gray-200 rounded"></div>
            </div>
            <div className="space-y-2">
              <div className="h-4 w-32 bg-gray-200 rounded"></div>
              <div className="flex items-center space-x-2">
                <div className="h-4 w-20 bg-gray-200 rounded"></div>
                <div className="h-4 w-16 bg-gray-200 rounded"></div>
              </div>
              <div className="h-4 w-16 bg-gray-200 rounded"></div>
            </div>
            <div className="h-10 bg-blue-200 rounded"></div>
            <div className="h-10 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EventSkeletonLoader;
